import Tab from '@/Modules/tab';
import React, { useState } from 'react';
import MyPageTopicGroups from './TopicGroups';

const MyPage = () => {
  const [activeKey, setActiveKey] = useState('1');

  return (
    <Tab
      activeKey={activeKey}
      onChange={setActiveKey}
      items={[
        {
          key: '1',
          label: 'Topic Groups',
          children: <MyPageTopicGroups />,
        },
      ]}
    />
  );
};

export default MyPage;
